<template>
  <FullScreenDialog
    v-model="dialog"
    without-padding
    title="Tipologia di Assenze"
    :route-father="routeFather"
  >
    <template v-slot:header-actions>
      <v-btn text link @click="goToNew" :disabled="isLicenseBlocked">
        <v-icon class="mr-2">mdi-plus</v-icon> Nuovo
      </v-btn>
    </template>
    <template v-slot:content>
      <div class="d-flex justify-center align-center mb-2" style="width: 100%">
        <AdvancedFilter
          style="width:99%; height: 100%"
          v-model="filtersValue"
          :show-filters="false"
          :external-filter="externalFilter"
          @apply-filters="applyFilters"
        >
          <template v-slot:chip-custom-name="{filter}">
            Nome: {{ filter.value }}
          </template>

        </AdvancedFilter>
      </div>
      <div 
        :style="{
          'height': $vuetify.breakpoint.smAndDown ? '81%' : '86%', 
          'overflow-y': 'hidden'
        }" 
        ref="dataTableWrapper"
      >
        <TypeDataTable
          v-model="selected"
          loading-text="Caricamento Tipologia di Assenze ..."
          :headers="headers"
          :loading="loading"
          :items="filteredAbsenceTypes"
          :page.sync="page"
          :row-per-page.sync="rowPerPage"
          :total-pages.sync="totalPages"
          :height="dataTableHeight"
          :show-select="false"
          @edit="handleEdit"
          @delete="handleDelete"
          @dblclick:row="handleEditDoubleClick"
        ></TypeDataTable>
      </div>
    </template>
  </FullScreenDialog >
</template>

<script>
import FullScreenDialog from '@/components/common/FullScreenDialog.vue'
import StandardMenu from '@/components/common/StandardMenu.vue'
import TypeDataTable from '@/components/common/TypeDataTable.vue'
import AdvancedFilter from "@/components/common/AdvancedFilter.vue";
import absenceTypeService from '@/services/presences/absenceTypes/absenceTypes.service.js'

export default {
  name: "AbsenceTypeList",
  components: {
    FullScreenDialog,
    AdvancedFilter,
    TypeDataTable,
    StandardMenu
  },
  data: function() {
    let props = this.$router.resolve({name: 'Presence'});

    return {
      dialog: true,
      loadingItems: false,
      loadingHeaders: false,
      routeFather: props.href,
      selected: undefined,
      dataTableHeightValue: 400,
      absenceTypes: [],
      headers: [],
      page: 1,
      rowPerPage: 20,
      totalPages: 0,
      resizeListener: undefined,
      externalFilter: { type: 'custom', operator: 'custom', field: 'name', name: 'Nome', label: 'Nome', color: "", value: undefined },
      filtersValue: [],
      isLicenseBlocked: undefined
    }
  },
  props: {
    filters: {
      type: Array,
      default: () => []
    }
  },
  mounted: function() {
    this.fetchHeaders()
    this.filtersValue = this.filters
    this.fetchAbsenceTypes()

    this.dataTableHeightValue = this.$refs.dataTableWrapper.offsetHeight - 60

    this.dataTableHeightValue = this.$refs.dataTableWrapper.offsetHeight - 60
    this.resizeListener = function() {
      this.dataTableHeightValue = this.$refs.dataTableWrapper.offsetHeight - 60
    }
    this.resizeListener = this.resizeListener.bind(this)
    window.addEventListener('resize', this.resizeListener)
  },
  beforeDestroy: function() {
    window.removeEventListener('resize', this.resizeListener)
  },
  methods: {
    fetchAbsenceTypes() {
      let filters = [...this.filtersValue]
      this.loadingItems = true
      absenceTypeService.list(this.page, this.rowPerPage, filters).then((results) => {
        if(this.rowPerPage != results.rowPerPage) {
          this.rowPerPage = results.rowPerPage
        }

        if(this.page != results.page) {
          this.page = results.page
        }

        this.totalPages = results.totalPages
        if(!!this.totalPages && this.totalPages < this.page) {
          this.page = this.totalPages
        }

        this.absenceTypes = results.rows
        this.loadingItems = false
      })
    },
    applyFilters() {
      this.fetchAbsenceTypes();
    },
    fetchHeaders() {
      this.loadingHeaders = true
      absenceTypeService.fields().then((headers) => {
        this.headers = headers
        this.loadingHeaders = false
      })
    },
    handleEdit(absenceType) {
      this.$router.push({
        name: 'AbsenceTypeEditForm',
        params: {
          id: absenceType.id,
          filters: this.filtersValue
        },
        query: {
          pathToGoBack: this.$router.resolve({name: 'AbsenceTypeList'}).href,
          pathName: "AbsenceTypeList"
        }
      })
    },
    handleEditDoubleClick(row, {item: absenceType}) {
      this.$router.push({
        name: 'AbsenceTypeEditForm',
        params: {
          id: absenceType.id,
          filters: this.filtersValue
        },
        query: {
          pathToGoBack: this.$router.resolve({name: 'AbsenceTypeList'}).href,
          pathName: "AbsenceTypeList"
        }
      })
    },
    handleDelete(absenceType) {
      let confirmed = confirm('Sei sicuro di voler eliminare ' + absenceType.name + ' ?')

      if(confirmed) {
        this.loadingItems = true
        absenceTypeService.delete(absenceType).then((results) => {
          if(!!results && results.error == 33)
            this.$delegates.snackbar('Attenzione! Hai delle assenze assegnati')
          else
            this.fetchAbsenceTypes()
          
          this.loadingItems = false
        })
      }
    },
    goToNew() {
      this.$router.push({
        name: 'AbsenceTypeNewForm',
        query: {
          pathToGoBack: this.$router.resolve({name: 'AbsenceTypeList'}).href
        }
      })
    }
  },
  computed: {
    filteredAbsenceTypes() {
      return this.absenceTypes
    },
    loading() {
      return this.loadingItems || this.loadingHeaders
    },
    dataTableHeight() {
      return this.dataTableHeightValue + 'px'
    }
  },
  watch: {
    page() {
      this.fetchAbsenceTypes()
    },
    rowPerPage() {
      this.fetchAbsenceTypes()
    },
  },
  isLicenseBlocked: {
    bind: 'isLicenseBlocked'
  }
}
</script>